import React from 'react';
import styles from './AdminProjectDetailInvites.module.scss';
import AdminTable, {
    AdminTableHeadRow,
    AdminTableRow,
} from '../../AdminTable/AdminTable';
import ProjectInvitation from '../../../types/invitation/ProjectInvitation';
import { Link } from 'react-router-dom';
import { ADMIN_INVITE_PATH } from '../../../../constants/route.constants';
import { ButtonVariants, Skeleton } from '@tcc-online/common-components';
import { useTranslate } from 'react-translate.ts';
import AdminProjectDetailCard from '../AdminProjectDetailCard/AdminProjectDetailCard';
import AdminButton from '../../buttons/AdminButton/AdminButton';

interface AdminProjectDetailInvitesProps {
    invites: ProjectInvitation[];
    loading?: boolean;
}

const skeletons = Array.from(new Array(5), (_, index) => (
    <Skeleton key={index} className={styles.skeleton} />
));

export default function AdminProjectDetailInvites(
    props: AdminProjectDetailInvitesProps,
) {
    const { invites, loading } = props;
    const translate = useTranslate();
    return (
        <AdminProjectDetailCard title={translate('Pozvánky')}>
            <AdminTable>
                <AdminTableHeadRow className={styles.row}>
                    <div>{translate('název')}</div>
                    {/* <div>{translate('datum odeslání')}</div>*/}
                    {/* <div>{translate('počet účastníků')}</div>*/}
                </AdminTableHeadRow>
                {!loading
                    ? invites.map((invitation: ProjectInvitation) => (
                          <AdminTableRow className={styles.row}>
                              <div className={styles.name}>
                                  {invitation.name}
                              </div>
                              {/* <div></div>*/}
                              {/* <div></div>*/}
                          </AdminTableRow>
                      ))
                    : skeletons}
            </AdminTable>
            <div className={styles.buttons}>
                <Link to={ADMIN_INVITE_PATH}>
                    <AdminButton>{translate('Prejit na pozvánky')}</AdminButton>
                </Link>
                <Link to={ADMIN_INVITE_PATH} state={{ newInvite: true }}>
                    <AdminButton variant={ButtonVariants.positive}>
                        {translate('Vytvorit pozvánku')}
                    </AdminButton>
                </Link>
            </div>
        </AdminProjectDetailCard>
    );
}
